import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { SwishFacade } from '@ridango/components';

@Component( {
    selector: 'rwidget-cart-swish',
    templateUrl: './cart-swish.component.html'
} )
export class CartSwishComponent implements OnInit {
    swishAccountField: FormControl;

    @Output() onSwishAccountFieldBlurred: EventEmitter<any> = new EventEmitter;
    @ViewChild('swishField') fieldEl: ElementRef;

    constructor(
        private swishFacade: SwishFacade,
    ) { }

    ngOnInit() {
        this.swishAccountField = new FormControl( '', [
            Validators.required, Validators.pattern(/^([+]467|07)\d{8}$/)
        ] );
    }

    setSwish() {
        this.swishFacade.setAccountId( this.swishAccountField.value );
    }

}
